import axios from 'axios';

const eventsApi = '/api/contactTracking';
export async function eventsApiGet(): Promise<string[]> {
  try {
    const { data } = await axios.get(eventsApi);
    return data.response ?? [];
  } catch (error) {
    // Пока убрали обработку ошибок https://jr.synergy.ru/browse/SFR-5823?focusedId=3311534&page=com.atlassian.jira.plugin.system.issuetabpanels:comment-tabpanel#comment-3311534
    // handleApiError(error);
  }

  return [];
}
